<template>
    <div class="content">
        <div v-bind:class="cssHeaderClass()">
            <h1 class="content__header__heading">{{ title }}</h1>
        </div>
        <blocks
            :slug="slug" 
            :blocks="blocks">
        </blocks>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import Blocks from '@/components/Blocks';

    export default {
        name: 'Subpage',
        components: {
            Blocks
        },
        computed: mapState([
            'ready',
            'pages'
        ]),
        data: function () {
            return {
                slug:null,
                subpage:null,

                title: null,
                color: null,
                blocks: [],
            }
        },

        created() {
            const slug = this.$route.params.slug || '';
            const subpage = this.$route.params.subpage || '';
            this.getSubPage(slug, subpage);
        },
        beforeRouteUpdate (to, from, next) {
            const slug = to.params.slug || '';
            const subpage = to.params.subpage || '';
            this.getSubPage(slug, subpage);
            next();
        },
        methods: {
            ...mapActions([
                'loadPage',
                'setBack']),
            cssHeaderClass() {
                let classes = { 'content__header' : true };
                if(this.color) {
                    classes['bg-color-' + this.color] = true;
                }
                return classes;
            },
            async getSubPage(slug, subpage) {
                try {

                    await this.loadPage(slug);

                    if(typeof this.pages[slug] != "undefined") {
                        for(const block of this.pages[slug].blocks) {
                            if(block.__typename == "blocks_popup_BlockType" && this.cleanURI(block.button) == subpage) {
                                this.title = block.heading;
                                this.color = this.pages[slug].color;
                                this.blocks = [
                                    {
                                        __typename: 'blocks_text_BlockType',
                                        text: block.text
                                    }
                                ];

                                let uri = slug;
                                if(this.pages[slug].parent) {
                                    uri = this.pages[slug].parent.slug + '/' + slug;
                                }

                                this.setBack(uri);
                                break;
                            }
                        }
                    }
                } catch (e) {
                    window.console.log(e);
                }
            },
            cleanURI(value) {
                return value.replace(/[^A-Za-z0-9 ]/g,'')
                            .replace(/\s/g, "-")
                            .replace(/\s{2,}/g,' ')
                            .toLowerCase();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .content {
        flex-grow: 1;
        flex-direction: column;

        display: flex;
        flex-direction: column;
        align-items: center;        

        &__header {
            width:100%;
            &__heading {
                padding:22px 0;

                color:#fff;
                text-align: center;
                font-size: 22px;
            }
        }

        &__audio {
            padding:50px 0 30px 0;
            text-align: center;

            &__heading {
                margin-top:30px;
                color:#fff;
            }
        }

    }
</style>